export default __webpack_public_path__ + "media/images/admin/menu-76c99ce2283fd6abd92149f129a556f2.svg";